import React from "react";
import { InterfaceListPageInitialState, PageNewState } from ".";

export const InterfaceListPageContext = React.createContext({
  pageState: InterfaceListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
